<!--eslint-disable vue/no-v-text-v-html-on-component-->
<template v-if="entity">
  <DynamicComponentActionElement
    v-bind="{...$props, ...$attrs}"
    :handle-custom-click="openSelectCollectionModal"
    :custom-value="collectionCount"
  />

  <SelectCollection
    v-if="openModal"
    :open="openModal"
    :item-id="entityId"
    :item-context="itemContext"
    :context="context"
    @close="closeSelectCollectionModal"
    @select="updateEntity"
  />
</template>

<script>
import SelectCollection from "%/dynamic-component-editor/components/SelectCollection.vue";
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentActionElement
  from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "SelectCollectionButton",
  components: { DynamicComponentActionElement, SelectCollection },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin],
  inheritAttrs: false,
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayName: "Save Button",
    elementGroup: "storyElements",
  },
  data() {
    return {
      openModal: false,
      collectionCount: 0,
    };
  },
  computed: {
    itemContext() {
      return "story";
    },
    context() {
      return "saved_posts";
    },
  },
  methods: {
    openSelectCollectionModal() {
      this.openModal = true;
    },
    closeSelectCollectionModal() {
      this.openModal = false;
    },
    updateEntity() {
      this.getEntity();
    },
  },
};
</script>
